<template lang="pug">
aside-modal(
    id="emailNotificationForm",
    ref="modal",
    :loading="loading"
)
    template(slot="header-text")
        | {{ modalTitle }}
    template(slot="body")
        div.padding
            form(@submit.prevent="save")
                fieldset
                    div.form-group
                        label Email Address
                        input.form-control(
                            v-model="form.email",
                            type="email",
                            placeholder="Enter email address",
                            required,
                            :disabled="loading"
                        )
                        span.form-error-msg.text-danger(
                            v-if="validationErrors.email"
                        ) {{ validationErrors.email[0] }}
    template(slot="footer")
        button.btn.btn-fw.primary(:disabled="loading" @click="save")
            | {{ okTitle }}
</template>

<script>
import event from './email-notification-event';

export default {
    data() {
        return {
            form: {
                id: null,
                email: '',
            },
            validationErrors: {},
            loading: false,
            isEdit: false,
        };
    },

    computed: {
        modalTitle() {
            return this.isEdit ? 'Edit Email' : 'Add Email';
        },

        okTitle() {
            return this.isEdit ? 'Update' : 'Add';
        },
    },

    mounted() {
        this.$on('show', (data = null) => {
            this.resetForm();

            if (data) {
                this.isEdit = true;
                this.form.id = data.id;
                this.form.email = data.email;
            } else {
                this.isEdit = false;
            }

            this.$refs.modal.$emit('show');
        });
    },

    methods: {
        save() {
            this.loading = true;
            this.validationErrors = {};

            let url = this.isEdit
                ? Laroute.route('franchise.setting.email_notification.update', {
                      id: this.form.id,
                  })
                : Laroute.route('franchise.setting.email_notification.store');

            let method = this.isEdit ? 'PUT' : 'POST';

            this.$http({
                method: method,
                url: url,
                data: this.form,
            })
                .then(() => {
                    this.$refs.modal.$emit('hide');
                    event.$emit(
                        this.isEdit ? 'email-updated' : 'email-created',
                    );
                    this.showSuccess(
                        this.isEdit
                            ? 'Email updated successfully'
                            : 'Email added successfully',
                    );
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.validationErrors = error.response.data.errors;
                    } else {
                        this.showError(
                            'An error occurred while saving the email',
                        );
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        resetForm() {
            this.form = {
                id: null,
                email: '',
            };
            this.validationErrors = {};
            this.loading = false;
            this.isEdit = false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/email-notification/email-notification-form.vue